import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionCreators from '../redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";

function* qnaCreate(action) {
    try {
        const response = yield call(() =>
            API.post(ROUTES.API_QNA_CREATE, action.payload)
        );
        console.log("login success", response);
    } catch (error) {
        let errors = error.response;
        let dataError = {};
        switch (errors.status) {
            case 401 :
                yield put(actionCreators.createQnaFaild(errors.data))
                break;
            case 404 :
                yield put(actionCreators.createQnaFaild(errors.data))
                break;
            case 422 :
                if (errors.data && errors.data.errors) {
                    Object.keys(errors.data.errors).map(function (key, index) {
                        dataError[key] = errors.data.errors[key][0];
                    });
                    yield put(actionCreators.createQnaFaild(dataError))
                }
                break;

            default :
                yield put(actionCreators.createQnaFaild())
                break;
        }

    }
}

function* qnaSaga() {
    yield takeLatest(actionTypes.CREATE_QNA, qnaCreate);
}

export default qnaSaga;
